import $ from 'jquery';

const removeEmptyParagraphs = {
  init() {
    $('p').each((_index, el) => {
      if ($(el).text().trim() === '' && $(el).html().trim() === '') {
        $(el).remove();
      }
    });
  },
};

export default removeEmptyParagraphs;
